(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["henry-party-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('henry-footer-localization')) {
    customElements.define('henry-footer-localization', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const details = this.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!details || !summary) return;
        const options = { signal: this.controller.signal };
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !details.open) return;
          event.preventDefault();
          details.open = false;
          summary.focus();
        }, options);
        document.addEventListener('click', (event) => {
          if (event.target instanceof Node && !this.contains(event.target)) details.open = false;
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget instanceof Node && !this.contains(event.relatedTarget)) details.open = false;
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  if (!customElements.get('henry-footer-menus')) {
    customElements.define('henry-footer-menus', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 750px)');
        this.updateLayout = () => {
          this.querySelectorAll('details').forEach((menu) => { menu.open = this.media.matches; });
        };
        this.updateLayout();
        this.media.addEventListener('change', this.updateLayout);
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.updateLayout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
